/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the percentage change between two numbers. Works for both increases and decreases, keeping the sign, with the formula and examples.`)
};

const es_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el cambio porcentual entre dos números. Funciona tanto para aumentos como para disminuciones, conservando el signo, con la fórmula y ejemplos.`)
};

const de_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne die prozentuale Veränderung zwischen zwei Zahlen. Funktioniert für Anstieg und Rückgang, behält das Vorzeichen bei, mit Formel und Beispielen.`)
};

const nl_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de percentageverandering tussen twee getallen. Werkt voor zowel stijgingen als dalingen, met behoud van het teken, plus formule en voorbeelden.`)
};

const fr_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la variation en pourcentage entre deux nombres. Fonctionne pour les augmentations et les diminutions, en conservant le signe, avec la formule et des exemples.`)
};

const it_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la variazione percentuale tra due numeri. Funziona sia per aumenti sia per cali, mantenendo il segno, con formula ed esempi.`)
};

const pt_br2_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a variação percentual entre dois números. Funciona tanto para aumentos quanto para diminuições, mantendo o sinal, com a fórmula e exemplos.`)
};

const pt_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a variação percentual entre dois números. Funciona para aumentos e diminuições, mantendo o sinal, com fórmula e exemplos.`)
};

const ja_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の間のパーセント変化を計算。増加・減少の両方に対応し符号を保持、計算式と例つきです。`)
};

const zh_pct_change_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个数字之间的百分比变化。同时适用于增长和减少并保留符号，附有公式和示例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_meta_description", locale)
	if (locale === "en") return en_pct_change_meta_description(inputs)
	if (locale === "es") return es_pct_change_meta_description(inputs)
	if (locale === "de") return de_pct_change_meta_description(inputs)
	if (locale === "nl") return nl_pct_change_meta_description(inputs)
	if (locale === "fr") return fr_pct_change_meta_description(inputs)
	if (locale === "it") return it_pct_change_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_meta_description(inputs)
	if (locale === "pt") return pt_pct_change_meta_description(inputs)
	if (locale === "ja") return ja_pct_change_meta_description(inputs)
	return zh_pct_change_meta_description(inputs)
};